import React from 'react';
import GenericCadastroPage from './GenericCadastroPage';

export default function AcaoObjetoPage() {
  const columns = [
    { key: 'descricao', label: 'Descrição' },
  ];

  const fields = [
    { name: 'descricao', label: 'Descrição', required: true },
  ];

  return (
    <GenericCadastroPage
      title="Ações e Objetos"
      description="Gerencie as ações e objetos de processos."
      tableName="acao_objeto_processo_v2"
      columns={columns}
      fields={fields}
    />
  );
}